import { lazy } from 'react';

export const staffGradFairModalComponentByType = {
  STAFF_GRAD_FAIR_REGISTER: lazy(() =>
    import('./Register/StaffGradFairRegisterModal').then((module) => ({
      default: module.StaffGradFairRegisterModal,
    })),
  ),
  STAFF_GRAD_FAIR_CANCEL_REGISTRATION: lazy(() =>
    import('./CancelRegistration/StaffGradFairCancelRegistrationModalContainer').then(
      (module) => ({
        default: module.StaffGradFairCancelRegistrationModalContainer,
      }),
    ),
  ),
  STAFF_GRAD_FAIR_SPONSOR_OR_HOST: lazy(() =>
    import('./RegistrationSponsorOrHost/StaffGradFairRegistrationSponsorOrHostModal').then(
      (module) => ({
        default: module.StaffGradFairRegistrationSponsorOrHostModal,
      }),
    ),
  ),
  STAFF_GRAD_FAIR_ADD_TO_WAITLIST: lazy(() =>
    import('./AddToWaitlist/StaffGradFairAddToWaitlistModal').then(
      (module) => ({ default: module.StaffGradFairAddToWaitlistModal }),
    ),
  ),
  STAFF_GRAD_FAIR_INVITE: lazy(() =>
    import('./Invite/StaffGradFairInviteModal').then((module) => ({
      default: module.StaffGradFairInviteModal,
    })),
  ),
  STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST: lazy(() =>
    import('./RemoveFromWaitlist/StaffGradFairRemoveFromWaitlistModal').then(
      (module) => ({ default: module.StaffGradFairRemoveFromWaitlistModal }),
    ),
  ),
} as const satisfies Record<string, unknown>;
